<template>
  <div class="element-input element-textbox element-textbox-splited element-textbox-auto-calculate" :class="{ disabled }">
    <div class="container">
      <div class="label" @click="clickHelp">
        <p>
          <span :class="{ active: dropbox && statusHelp }">{{ label }}</span>
          <img v-if="dropbox" :src="statusHelp ? '../static/cancel_blue.png' : '../static/help_gray.png'" />

        </p>
        <div class="dropbox" v-if="dropbox && statusHelp">
          {{ dropbox }}
        </div>
      </div>

      <template v-if="mode == 'area'">
        <div class="body">
          <input type="text" v-on:input="changeFireArea" v-model="model[0].value" :disabled="disabled" :placeholder="placeholder[0].value" />
          <label class="back">m<span>2</span></label>
        </div>
        <div class="body" >
          <input type="text" v-on:input="changeFirePyung" v-model="model[1].value" :disabled="disabled" :placeholder="placeholder[1].value" />
          <label class="back">평</label>
        </div>
        <div class="error" v-if="error">{{ error }}</div>
      </template>

      <template v-if="mode == 'pension'">
        <div class="body">
          <input type="text" v-on:input="changePensionMonth" v-model="model[0].value" :disabled="disabled" :placeholder="placeholder[0].value" />
          <label class="front">월</label>
          <label class="back">만원</label>
        </div>
        <div class="body" >
          <input type="text" v-on:input="changePensionYear" v-model="model[1].value" :disabled="disabled" :placeholder="placeholder[1].value" />
          <label class="front">연</label>
          <label class="back">만원</label>
        </div>
        <div class="error" v-if="error">{{ error }}</div>
      </template>

      <template v-if="mode == 'building-price'">
        <div class="body">
          <input type="text" v-on:input="changeBuildingPriceValue" v-model="model[0].value" :disabled="disabled" :placeholder="placeholder[0].value" />
          <label class="back">만원</label>
        </div>
        <div class="body">
          <input type="text" v-on:input="changeBuildingPriceDest" v-model="model[1].value" :disabled="true" :placeholder="placeholder[1].value" />
          <label class="front">(</label>
          <label class="back">억원 )</label>
        </div>
        <div class="error" v-if="error">{{ error }}</div>
      </template>

    </div>
  </div>
</template>
<script>
export default {
  props: [ "value", "label", "type", "mode", "year", "error", "disabled", "placeholder", "dropbox", "area" ],
  created() {
  },
  data(){
    return {
      statusHelp: false,
    }
  },
  computed: {
    model: {
      get(){
        return this.value;
      },
      set( value ){
        this.$emit( "input", value );
      }
    }
  },
  created() {
    var temp = [
      { value: "", label: "만원" },
      { value: "", label: "억원" },
    ];
    if( this.area ){
      temp[0].value = this.area * 300;
      temp[1].value = temp[0].value / 10000;
      temp[1].value = temp[1].value.toFixed(1);
      this.$emit( "input", temp );
    }
  },
  methods: {
    selectItem( value ){
      this.$emit( "input", value );
    },

    changePensionMonth(){
      /*if(this.type === '연말정산 세액공제') {
        if(this.model[0].value < 10) this.model[0].value = 10;
        if(this.model[0].value > 33) this.model[0].value = 33;
      }
      else {
        if(this.model[0].value < 10) this.model[0].value = 10;
        if(this.model[0].value > 150) this.model[0].value = 150;
      }*/

      this.model[1].value = this.year * this.model[0].value;
    },

    changePensionYear(){
      /*if(this.type === '연말정산 세액공제') {
        if(this.model[1].value > 400) this.model[1].value = 400;
      }
      else{
        if(this.model[1].value > 1800) this.model[1].value = 1800;
      }*/

      this.model[0].value = Math.round(this.model[1].value / this.year);
    },

    changeFireArea(){
      this.model[1].value = this.model[0].value / 3.306;
      this.model[1].value = this.model[1].value.toFixed(1);
    },

    changeFirePyung(){
      this.model[0].value = this.model[1].value * 3.306;
      this.model[0].value = this.model[0].value.toFixed(2);
    },

    changeBuildingPriceValue(){
      this.model[1].value = this.model[0].value / 10000;
      this.model[1].value = this.model[1].value.toFixed(1);
    },

    changeBuildingPriceDest(){

    },

    clickHelp(){
      this.statusHelp = !this.statusHelp
    },

  }

}
</script>
